/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import { defaultPaths } from './default-paths';

const endpointPaths = (base: string) => ({
  ...defaultPaths(base),
  list: `${base}/list`,
  create: `${base}/create`,
  detail: (endpointId: string) => {
    const endpointBase = `${base}/${endpointId}`;

    return {
      ...defaultPaths(endpointBase),
      update: `${endpointBase}/update`,
      overview: `${endpointBase}/overview`,
      playground: `${endpointBase}/playground`,
      metrics: `${endpointBase}/metrics`,
      logs: `${endpointBase}/logs`,
      versions: `${endpointBase}/versions`,
    };
  },
});

const finetuningPaths = (base: string) => ({
  ...defaultPaths(base),
  list: `${base}/list`,
  create: `${base}/create`,
  detail: (finetuningId: string) => {
    const finetuningBase = `${base}/${finetuningId}`;

    return {
      ...defaultPaths(finetuningBase),
      overview: `${finetuningBase}/overview`,
      'output-models': `${finetuningBase}/output-models`,
    };
  },
});

const modelPaths = (base: string) => ({
  ...defaultPaths(base),
  list: `${base}/list`,
  detail: (modelId: string) => {
    const modelBase = `${base}/${modelId}`;

    return {
      ...defaultPaths(modelBase),
      overview: `${modelBase}/overview`,
      versions: `${modelBase}/versions`,
      endpoints: `${modelBase}/endpoints`,
      files: `${modelBase}/files`,
    };
  },
});

const datasetPaths = (base: string) => ({
  ...defaultPaths(base),
  list: `${base}/list`,
  create: `${base}/create`,
  detail: (datasetId: string) => {
    const datasetBase = `${base}/${datasetId}`;

    return {
      ...defaultPaths(datasetBase),
      overview: `${datasetBase}/overview`,
    };
  },
});

const documentPaths = (base: string) => ({
  ...defaultPaths(base),
  list: `${base}/list`,
});

const projectPaths = (base: string) => ({
  ...defaultPaths(base),
  list: `${base}/list`,
  detail: (projectId: string) => {
    const projectBase = `${base}/${projectId}`;

    return {
      ...defaultPaths(projectBase),
      endpoint: endpointPaths(`${projectBase}/endpoint`),
      finetuning: finetuningPaths(`${projectBase}/fine-tuning`),
      model: modelPaths(`${projectBase}/model`),
      dataset: datasetPaths(`${projectBase}/dataset`),
      document: documentPaths(`${projectBase}/document`),
      monthlyUsage: `${projectBase}/monthly-usage`,
      settings: `${projectBase}/settings`,
    };
  },
});

export const dedicatedEndpointsPaths = (base: string) => ({
  ...defaultPaths(base),
  landing: `${base}/landing`,
  project: projectPaths(`${base}/project`),
});
